import React, { useEffect } from 'react';
import { footerLinks, socialMedia } from '../constants';
import { FaInstagram, FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';
import Logo from '../assets/img/logoblue.png';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../styles/Footer.css';

const socialIconStyle = {
  borderRadius: '50%', paddin1g: '8px', 
};

const Footer = () => {

  // Removed isMobile state as responsiveness will be handled purely by CSS media queries.
  // const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.fromTo(
      ".foot_tit",
      { opacity: 0, y: 50 }, // Inițial, ascuns și deplasat în sus
      {
        opacity: 1,
        y: 0,
        duration: 1.2,
        ease: "power4.out",
        scrollTrigger: {
          trigger: ".foot_tit",
          start: "top 90%",
          toggleActions: "play none none none",
        },
      }
    );
  }, []);

  return (
    <section className='footer'>
      <div className="flex flex-col footer_wrap_top">
        <div className="foot_tit flex md:flex-row flex-col justify-between leading-[1] text-[3.5rem] font-normal tracking-tight mb-3 text-white">
          <h1 className='text-left'>We re social</h1>
          <h1 className='text-right'>get in touch</h1>
        </div>

        <div className="cent_bottom">
          {/* Simplified classes for links, relying on CSS media queries */}
          <div className={`links w-full flex justify-between items-start xl:gap-4 md:gap-2 md:mt-0 py-5 footer-links`}>
            {footerLinks.map((footerlink, index) => (
              <div
                key={footerlink.title}
                className={`columns text-left items-start flex flex-col md:w-auto w-1/2 md:ml-2 sm:mx-auto my-4 md:mb-0 sm:min-w-[150px]`}
              >
                <h4 className="font-poppins font-medium text-[18px] leading-[27px] text-white">
                  {footerlink.title}
                </h4>
                <ul className="list-none mt-4 flex-col">
                  {footerlink.links.map((link, index) => (
                    <li
                      key={link.name}
                      className={`font-poppins leading-[20px] text-neutral-400 cursor-pointer relative group whitespace-nowrap ${
                        index !== footerlink.links.length - 1 ? 'mb-2' : 'mb-0'
                      }`}
                    >
                      <div className="ftr_list">
                        <span className="link-hover-slide font-light">{link.name}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            {/* A patra coloană pentru iconuri sociale */}
            <div class="footer-subscribe md:w-auto w-1/2 h-12">
              <div className="relative flex justify-between">
                <input
                  placeholder="Email"
                  type="email"
                  name="member[email]"
                  id="member_email"
                  className="Recive-offers-input relative rounded-full border
                  border-neutral-400 focus:border-indigo-700 outline-none bg-transparent w-full
                  md:py-4 py-2 px-2 text-sm text-gray-500  z-0"
                />
                <div className="mb">
                  <button
                    className="Recive-offers-button absolute mt-2 transform right-0 mr-2 text-white rounded-full  py-[0.2rem] px-4 transition duration-500 border border-indigo-700 overflow-hidden group"
                  >
                    <p className="relative z-10">Receive</p>
                    <span className="absolute inset-0 bg-indigo-700 transition-transform duration-500 transform group-hover:-translate-x-full"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-between items-end py-6">
            <Link to="/">
              <img src={Logo} alt="hoobank" className="mt-4 w-[50px] h-[60px] text-left object-contain logo-footer" />
            </Link>
            <div
              className={`social-icons-column flex items-center md:mt-0 mt-2`}
            >
              <div className="flex gap-[0.2rem] social-icons">
                {socialMedia.map((social, index) => (
                  <a
                    key={social.id}
                    href={social.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cursor-pointer "
                  >
                    <div
                      className="soc_icons hover:bg-indigo-700 p-2"
                      style={{ ...socialIconStyle, transition: 'background-color 0.5s' }}
                    >
                      {index === 0 && (
                        <FaInstagram className="w-[18px] h-[18px] object-contain text-indigo-700 text-white" />
                      )}
                      {index === 1 && (
                        <FaFacebook className="w-[18px] h-[18px] object-contain text-indigo-700 text-white" />
                      )}
                      {index === 2 && (
                        <FaTwitter className="w-[18px] h-[18px] object-contain text-indigo-700 text-white" />
                      )}
                      {index === 3 && (
                        <FaLinkedin className="w-[18px] h-[18px] object-contain text-indigo-700 text-white" />
                      )}
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;